import React from 'react';
import { Box, Typography, Container, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

const AdminFooterContainer = styled(Box)(({ theme }) => ({
  backgroundColor: '#f8f9fa',
  borderTop: '1px solid #e0e0e0',
  padding: theme.spacing(2, 0),
  marginTop: 'auto',
  position: 'relative',
  bottom: 0,
  width: '100%',
}));

const AdminFooter = () => {
  return (
    <AdminFooterContainer>
      <Container maxWidth="lg">
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: 1
        }}>
          <Typography variant="body2" color="text.secondary">
            ©Copyright All Rights Reserved 2025 All In One Construction - Admin Panel
          </Typography>
          <Grid item xs={12} md={6} sx={{ textAlign: { xs: 'center', md: 'right' } }}>
          <Typography variant="body2" color="text.secondary">
            Developed by: talhayaseentdr@gmail.com
          </Typography>
          <Typography variant="body2" color="text.secondary">
            +92 317 8502328
          </Typography>
          </Grid>
        </Box>
      </Container>
    </AdminFooterContainer>
  );
};

export default AdminFooter;
